<template>
  <div class="content-box">
    <div class="login-top">
      <div class="inline logo">
        <img src="../assets/logo.png" alt=""/>
      </div>
      <div class="inline go-back" @click="$router.go(-1)">返回</div>
      <span class="inline fr">修改发票信息</span>
    </div>
    <div class="content-box-sco">
      <div class="form-box">
        <p v-if="info && info.type">状态：{{info.type === 0 ? '待付款' : (info.type === 1 ? '已取消' : (info.type === 2 ? '已付款' : (info.type === 3 ? '已开票' : '')))}}</p>
        <p v-if="info && info.price">金额：{{info && info.price ? info.price : ''}}元</p>
        <p>项目：{{info && info.service ? info.service      .name : ''}}</p>
        <div class="form-title">发票信息</div>
        <el-form :model="form" label-position="left" label-width="110px" ref="invoice" class="demo-form">
          <el-form-item class="radio-item" prop="invoice_type" :rules="[{ required: true, message: '不能为空' }]">
             <el-radio-group @change="change" v-model="form.invoice_type">
              <el-radio label="0">不开发票</el-radio>
              <el-radio label="1">电子发票(个人)</el-radio>
              <el-radio label="2">电子发票(企业)</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '1'" class="invoice-item" label='姓名' prop="invoice_title" :rules="[{ required: true, message: '不能为空' }, { pattern: /^([\u4e00-\u9fa5]{2,20}|[a-zA-Z\.\s]{2,20})$/, message: '请输入正确姓名'}]">
            <el-input maxlength="200" v-model="form.invoice_title" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='名称' prop="invoice_title" :rules="[{ required: true, message: '不能为空' }, { pattern: /^([\u4e00-\u9fa5]{2,20}|[a-zA-Z\.\s]{2,20})$/, message: '请输入正确名称'}]">
            <el-input maxlength="200" v-model="form.invoice_title" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='纳税人识别号' prop="invoice_ident" :rules="[{ required: true, message: '不能为空' }]">
            <el-input maxlength="200" v-model="form.invoice_ident" placeholder="请输入纳税人识别号"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='纳税人地址' prop="invoice_addr" :rules="[{ required: true, message: '不能为空' }]">
            <el-input maxlength="200" v-model="form.invoice_addr" placeholder="请输入纳税人地址"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='纳税人电话' prop="invoice_phone" :rules="[{ required: true, message: '不能为空' }, { pattern: /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/, message: '请输入正确电话'}]">
            <el-input maxlength="200" v-model="form.invoice_phone" placeholder="请输入纳税人电话"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='开户银行' prop="invoice_bank" :rules="[{ required: true, message: '不能为空' }]">
            <el-input maxlength="200" v-model="form.invoice_bank" placeholder="请输入开户银行"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='银行账户' prop="invoice_bank_account" :rules="[{ required: true, message: '不能为空' }]">
            <el-input maxlength="200" v-model="form.invoice_bank_account" placeholder="请输入银行账户"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type !== '0'" class="invoice-item" label='邮箱' prop="invoice_mail" :rules="[{ required: true, message: '不能为空' }, {pattern:  /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/, message: '格式不正确'}]">
            <el-input maxlength="200" v-model="form.invoice_mail" placeholder="电子发票将发送至您邮箱"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='备注' prop="comment">
            <el-input type="textarea" maxlength="200" v-model="form.comment" placeholder="备注"></el-input>
          </el-form-item>
          <el-form-item v-if="form.invoice_type === '2'" class="invoice-item" label='收票人手机' prop="invoice_recv_phone" :rules="[{ pattern: /^1[3456789]\d{9}$/, message: '请输入正确手机号' }]">
            <el-input maxlength="200" v-model="form.invoice_recv_phone" placeholder="请输入收票人手机"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-row class="tc">
        <el-button :loading="btnLoading" type="primary" @click="handleLogin">确认修改</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getInfo, changeService } from '@/api'
export default {
  data () {
    return {
      form: {
        invoice_type: '0',
        invoice_addr: '',
        invoice_title: '',
        invoice_mail: '',
        invoice_ident: '',
        invoice_phone: '',
        invoice_bank: '',
        invoice_bank_account: '',
        invoice_recv_phone: '',
        comment: ''
      },
      info: {},
      btnLoading: false
    }
  },
  methods: {
    change (val) {
      // if (val === '1') {
      //   this.form.invoice_addr = ''
      // } else if (val === '2') {
      //   this.form.invoice_mail = ''
      // } else {
      //   this.form.invoice_addr = ''
      //   this.form.invoice_mail = ''
      // }
    },
    handleLogin () {
      this.$refs.invoice.validate(valid => {
        if (valid) {
          this.submit()
        }
      })
    },
    submit () {
      this.btnLoading = true
      var formData = new FormData()
      formData.append('patient_name', this.form.invoice_title)
      formData.append('doctor_name', this.info.doctor_name)
      formData.append('invoice_addr', this.form.invoice_addr)
      formData.append('invoice_title', this.form.invoice_title)
      formData.append('invoice_mail', this.form.invoice_mail)
      formData.append('invoice_type', this.form.invoice_type)
      formData.append('hospital_id', this.$route.query.hospital)
      formData.append('token', this.$cookies.get('h5_token'))
      formData.append('invoice_mail', this.form.invoice_mail)
      formData.append('invoice_ident', this.form.invoice_ident)
      formData.append('invoice_phone', this.form.invoice_phone)
      formData.append('invoice_bank', this.form.invoice_bank)
      formData.append('invoice_bank_account', this.form.invoice_bank_account)
      formData.append('invoice_recv_phone', this.form.invoice_recv_phone)
      formData.append('comment', this.form.comment)
      changeService(this.$route.query.orderId, formData).then(res => {
        if (res.code === -1 && res.msg === '未登录') {
          this.$notify.error({
            message: res.msg,
            showClose: false,
            offset: 100,
            duration: 2000
          })
          this.$router.push({path: '/login', query: {device: this.$route.query.device, hospital: this.$route.query.hospital}})
        } else {
          this.$notify.success({
            message: '修改成功',
            showClose: false,
            offset: 100,
            duration: 2000
          })
          this.$router.push({path: '/goods', query: {device: this.$route.query.device, hospital: this.$route.query.hospital}})
        }
      }).finally(() => {
        this.btnLoading = false
      })
    }
  },
  mounted () {
    if (this.$route.query.orderId) {
      var formData = new FormData()
      formData.append('token', this.$cookies.get('h5_token'))
      getInfo(this.$route.query.orderId, formData).then(res => {
        this.info = res.data
        this.form.invoice_type = res.data.invoice_type + ''
        this.form.invoice_title = res.data.invoice_title
        this.form.invoice_mail = res.data.invoice_mail
        this.form.invoice_addr = res.data.invoice_addr
        this.form.invoice_ident = res.data.invoice_ident
        this.form.invoice_phone = res.data.invoice_phone
        this.form.invoice_bank = res.data.invoice_bank
        this.form.invoice_bank_account = res.data.invoice_bank_account
        this.form.invoice_recv_phone = res.data.invoice_recv_phone
        this.form.comment = res.data.comment
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.title-pro{
  line-height: 60px;
  font-size: 16px;
  color: #539edf;
}
.form-title{
  margin-top: 5%;
  font-size: 16px;
  color: #539edf;
  line-height: 30px;
}
.formtip-txt{
  line-height: 30px;
}
p{
  padding-left: 2%;
  line-height: 40px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/modify.vue